import { PayTypeValueZAF } from "../enums/pay-type-ZAF.enum";
import { PayTypeValue } from "../enums/pay-type.enum";

export class PayTypeConstants {
    public static payTypes = [
        { name: 'Savings', value: PayTypeValue.savings },
        { name: 'Current', value: PayTypeValue.current }
    ];

}

export class PayTypeConstantsZAF {
    public static payTypesZAF = [
        { name: 'Savings',value: PayTypeValueZAF.savings },
        { name: 'Cheque',value: PayTypeValueZAF.cheque },
    ];
    
}


// WEBPACK FOOTER //
// ./src/app/common/constants/pay-type-constants.ts